import { Type } from 'class-transformer';
import { Location } from '@/modules/backend/Entities/Location';
import { Location as RouterLocation } from 'vue-router/types/router';

export class Account {
  public id!: number;

  private name!: string;

  private content!: string;

  @Type(() => Location)
  private readonly location!: Location;

  public getId(): number {
    return this.id;
  }

  public getCompoundId(): number {
    return Number(this.getLocation().getCompoundId().toString() + this.getId().toString());
  }

  public getName(): string {
    return this.name;
  }

  public getContent(): string {
    return this.content;
  }

  public getLocation(): Location {
    return this.location;
  }

  public getRouteLocation(): RouterLocation {
    return {
      name: 'dashboard.account.counters',
      params: {
        accountId: String(this.getId()),
      },
    };
  }
}
